import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import WhatsAppFloatingButton from "@/pages/WhatsappFloatingButton";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          
        </Routes>
        <WhatsAppFloatingButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
